import React, { FC } from 'react';
import './Layout.scss';
import classnames from 'classnames';
import { LayoutProps } from './models';
import Seo from '../Seo';

const Layout: FC<LayoutProps> = ({ className, children, language, pageTitle = '', ...rest }) => {
  const rtlLanguages = ['ar'];

  return (
    <div
      className={classnames('layout', className, {
        'text-direction--rtl': rtlLanguages.includes(language),
      })}
      {...rest}
    >
      <Seo language={language} pageTitle={pageTitle} />
      <link href={process.env.GATSBY_IMAGE_CLOUD_SERVER} />
      <main id="main" className="layout__main">
        {children}
      </main>
    </div>
  );
};

export default Layout;
